// src/pages/dashboard/Premium/PremiumPreview.tsx
import React from 'react';
import PremiumBannerLocked from '../../../components/Premium/Locked/PremiumBannerLocked';
import PremiumToolsGrid from '../../../components/Premium/PremiumToolsGrid';
import PremiumHistory from '../../../components/Premium/PremiumHistory';
import { PremiumQuotas } from '../../../api/premiumService';

const ZERO_QUOTAS: PremiumQuotas = {
  leaked_data: 0, emails: 0, employees: 0, ips: 0, ipwhois: 0, subdomains: 0,
  typosquatting: 0, names_tld: 0, whois: 0, dns_all_records: 0, wafw00f: 0,
  wappalyzer: 0, gau: 0, spoofornot: 0, screenshot: 0,
};

interface Props {
  onGoInvestigations?: () => void;  // 👈 nuevo
}

const PremiumPreview: React.FC<Props> = ({ onGoInvestigations }) => {
  return (
    <div className="mx-auto max-w-6xl">
      <PremiumBannerLocked onGoInvestigations={onGoInvestigations} />
      <PremiumToolsGrid quotas={ZERO_QUOTAS} locked />
      <PremiumHistory history={[]} toolFilter="all" setToolFilter={() => {}} />
    </div>
  );
};

export default PremiumPreview;
